import * as types from "../types";

const initialState = {
  Token: null,
  Level: 3,
  AdminLevel: 2,
  Load: false,
  Trades: [
    { data: null },
    { data: null },
    { data: null },
    { data: null },
    { data: null },
  ],
  Stock: null,
  Provinces: null,
  uploadCount: 0,
  uploadDate: null,
  Credit: null,
  MobileNumber: null,
  FirstName: null,
  LastName: null,
  Code: null,
  Myname: null,
  Permission: null,
  Summary: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_TOKEN:
      return { ...state, Token: action.Token };
    case types.DELETE_TOKEN:
      localStorage.clear();
      return initialState;
    case types.LOGIN_INFO:
      return { ...state, ...action.payload };
    case types.SET_TRADES:
      const { response, selectedIndex } = action;
      const _trades = [...state.Trades];

      _trades[selectedIndex] = { data: response.data };
      return {
        ...state,
        Trades: [..._trades],
      };
    case types.EMPTY_TRADES:
      return {
        ...state,
        Trades: [
          { data: null },
          { data: null },
          { data: null },
          { data: null },
          { data: null },
        ],
      };
    case types.SET_STOCK:
      return { ...state, Stock: action.Stock };
    case types.CLEAR_STOCK:
      return { ...state, Stock: null };
    case types.SET_AUTH:
      return { ...state, Auth: action.data };
    case types.SET_PROVINCES:
      return { ...state, Provinces: action.data };
    case types.SET_CREDIT:
      return { ...state, Credit: action.credit };
    case types.NEW_UPLOAD:
      return {
        ...state,
        uploadCount: state.uploadCount + 1,
        uploadDate: new Date(),
      };
    case types.SET_LOAD:
      return { ...state, Load: action.load };
    case types.SET_LEVEL:
      return { ...state, AdminLevel: action.level };
    case types.SET_MOBILE:
      return { ...state, MobileNumber: action.mobile };

    case types.SET_FIRST_NAME:
      return { ...state, FirstName: action.firstName };

    case types.SET_LAST_NAME:
      return { ...state, LastName: action.lastName };

    case types.SET_CODE:
      return { ...state, Code: action.code };

    case types.SET_MYNAME:
      return { ...state, Myname: action.myname };
    case types.SET_PERMISSION:
      return { ...state, Permission: action.permission };
    case types.SET_DASHBOARDSUMMARY:
      return { ...state, Summary: action.summary };
    default:
      return state;
  }
};

export default reducer;
